<div class="relative">
  <mat-form-field class="w-100 mat-field-fill-bg" appearance="outline" [floatLabel]="selectedOptions.length ? 'always': 'auto'">

    <i
      [ngClass]="[iconClass || 'fi fi-br-search', 'p-15', 'prefix-icon-search']"
      matIconPrefix
      (click)="iconClick.emit($event)"
    >
    </i>

    <div [style.margin]="selectedOptions.length ? '-10px 10px -10px 0': ''">

      @for (option of selectedOptions; track option) {
        <mat-chip (removed)="onRemove(option)" style="margin: 5px 5px 5px 0;">
          @if (option.image) {
            <img
              matChipAvatar class="option-image chip-image bg-primary" [src]="option.image" alt="{{option.label}}"
            />
          }
          <span class="relative">
            <small class="option-field-label">
              {{option.fieldLabel}}
            </small>
            <span class="option-value-label">
              {{ option.label }}
            </span>
          </span>
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      }

      <input
        matInput
        (blur)="onBlur()"
        (focus)="onFocus()"
        (keyup)="onKeyUp()"
        [(ngModel)]="search"

        [matAutocomplete]="auto"
        [style.width]="((search?.length || 0) * 8 + 5) + 'px'"

        type="text"
        style="max-width: 100%"
      />
    </div>
    <mat-label> Busqueda rapida </mat-label>



    <!--<mat-icon matSuffix>close</mat-icon>-->

    <mat-autocomplete #auto="matAutocomplete" disableRipple="true"  (optionSelected)="optionSelect($event)">

      @for (option of optionList; track option) {
        @if (!valueSelected.has(option.value)) {
          <mat-option [value]="option.value" (click)="onSelect(option)">
            <div class="flex align-item-center option-item text-black-500">
              @if (option.image) {
                <div class="flex-shrink-0 m-r-10">
                  <img class="option-image" [src]="option.image" alt="{{option.label}}" />
                </div>
              }

              <div class="flex-grow-1 p-2">
                <div><strong>{{ option.label }}</strong></div>
                <small class="accent-500">{{ option.fieldLabel }}</small>
              </div>
            </div>
          </mat-option>
        }
      } @empty {
        @if (search){
          <mat-option disabled="true">No se encontraron resultados</mat-option>
        } @else {
          <mat-option disabled="true">Escribe algo para buscar ...</mat-option>
        }
      }
    </mat-autocomplete>

  </mat-form-field>
  @if (Number.isFinite(elementCount)) {
    <div class="bg-accent-300 message-count" >
      {{ elementCount || 0 }} {{ elementCount === 1 ? 'elemento encontrado' : 'elementos encontrados' }}
    </div>
    <br/>
  }

</div>

